import { render } from "./DetalleTutela.vue?vue&type=template&id=76b60f5e&scoped=true"
import script from "./DetalleTutela.vue?vue&type=script&lang=js"
export * from "./DetalleTutela.vue?vue&type=script&lang=js"

import "./DetalleTutela.vue?vue&type=style&index=0&id=76b60f5e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b60f5e"]])

export default __exports__